import script from "./SubNavigation.vue?vue&type=script&setup=true&lang=ts"
export * from "./SubNavigation.vue?vue&type=script&setup=true&lang=ts"

import "./SubNavigation.vue?vue&type=style&index=0&id=38f27c01&lang=scss"

const __exports__ = script;

export default __exports__